import { downgradeComponent } from "@angular/upgrade/static";
import { RouteConfigHelperProvider } from "@services/routeConfigHelper.provider";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { FleetNavigationModule } from "./fleet.navigation";
import { VehiclesPageRouteComponent } from "./_routes/vehicles/vehicles.component";



export class Config {

    static $inject = ["$stateProvider", "routeConfigHelperProvider"];

    constructor(
        private $stateProvider: StateProvider,
        private routeConfigHelperProvider: RouteConfigHelperProvider) {

        $stateProvider.state(FleetNavigationModule.VehiclesNew, {
            url: "/vehicles-new",
            views: { "content@app": { component: "vehiclesPage" } },
            data: { translation: 'Common.Vehicles', subtitle: "View live vehicle positional data alongside other metrics such as CAN, Video, Temperature etc" }
        });


    }
}

angular
    .module("app.fleet", ["app.directives"])
    .config(Config)

    .directive("vehiclesPage", downgradeComponent({ component: VehiclesPageRouteComponent }));
